import { DateTime, Settings } from 'luxon';

export default {
  methods: {
    closeCalendar(model, formatFrom, formatTo, selectedDates, dateStr, fp) {
      Settings.throwOnInvalid = true;
      let date = fp._input.value;
      if (formatFrom && date) {
        try {
          date = DateTime.fromFormat(fp._input.value, formatFrom).toFormat(formatTo);
        } catch (e) {
          date = null;
        }
      }
      const modelPath = model.split('.');
      if (modelPath.length === 3) {
        this[modelPath[0]][modelPath[1]][modelPath[2]] = date;
      } else {
        this[modelPath[0]][modelPath[1]] = date;
      }

      fp.setDate(date);
    },
    selectAllOnOpen(ref) {
      setTimeout(() => {
        let item = this.$refs[ref].$parent.$el.querySelector('input[type=text]');
        item.setSelectionRange(0, item.value.length);
      }, 1);
    },
  },
};
